import {FC} from "react";
import styled from "@emotion/styled";
import {LINE_UP} from "modules/constants";
import {ITeam} from "modules/types";
import {PlayersRow} from "./PlayersRow";
import {breakpoints} from "assets/theme";

const Wrapper = styled.div`
	padding: 20px 0;

	@media (min-width: ${breakpoints.mobile}) {
		padding: 30px;
	}
`;

interface ITeamView {
	team: ITeam;
}

export const TeamView: FC<ITeamView> = ({team}) => {
	return (
		<Wrapper className="field">
			{LINE_UP.map((item, i) => (
				<PlayersRow players={item} team={team} key={i} />
			))}
		</Wrapper>
	);
};
